<template>
	<div class="minusplusnumber">
		<div class="mpbtn minus" v-on:click="mpminus()">
			-
		</div>
		<div id="field_container">
			<input type="number" v-model="newValue" disabled />
		</div>
		<div class="mpbtn plus" v-on:click="mpplus()">
			+
		</div>
	</div>
</template>

<script>
	export default {

        /* >>> *************************************************************** / /* Props */
		props: {

			value: {
				default: 0,
				type: Number
			},
			min: {
				default: 1,
				type: Number
			},
			max: {
				default: undefined,
				type: Number
			}

		}, // eof props{}
        /* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Data */
		data () {

			return {
				newValue: 0
			}

        }, // eof data()
        /* <<< ****************************************************************/





        /* >>> *************************************************************** / /* Watch */
		watch: {

			value: {
				handler: function (newVal, oldVal) {
					this.newValue = newVal;
				}
			}

        }, // eof watch{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

			this.newValue = this.value;

		}, // eof created()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
		methods: {

			getNotificationClass (notification) {

				return `alert alert-${notification.type}`;

			},

			mpplus: function () {

				if (this.max === undefined || (this.newValue < this.max)) {
					this.newValue = this.newValue + 1;
					this.$emit('input', this.newValue);
				}

			},

			mpminus: function () {

				if ((this.newValue) > this.min) {
					this.newValue = this.newValue - 1;
					this.$emit('input', this.newValue);
				}

			}

        }, // eof methods{}
        /* <<< ****************************************************************/
	}
</script>

<style lang="scss" scoped>
	.minusplusnumber {
		border:1px solid silver;
		border-radius:5px;
		xbackground-color: #A2CB5A; /* fff */
		Xmargin:0 5px 0 5px;
		display:inline-block;
		user-select: none;

	}
	.minusplusnumber div {
		display:inline-block;
	}
	.minusplusnumber #field_container input {
		width:35px;
		text-align:center;
		font-size:12px;
		padding:3px;
		border:none;
		background-color: #ffffff;
		color: #000;
	}
	.minusplusnumber .mpbtn {
		padding:3px 10px 3px 10px;
		cursor:pointer;
		border-radius:5px;
		color: #ffffff;
		font-size: 0.9167em;
		font-weight: 600;
		background-color: #A2CB5A; /* fff */
	}
	.minusplusnumber .mpbtn:hover {
		background-color:rgb(129, 160, 76); /* ddd */
	}
	.minusplusnumber .mpbtn:active {
		background-color:rgb(110, 136, 66); /* c5c5c5 */
	}
</style>
